import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { COMPANY } from "../../lib/constants";

export const CTASection = () => {
  const waLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(
    "Hi M Brothers, I'd like a free cleaning quote."
  )}`;
  return (
    <section data-testid="cta-section" className="relative py-20 md:py-24 bg-mesh-dark text-white overflow-hidden grain-overlay">
      {/* Animated blobs */}
      <div className="pointer-events-none absolute -right-32 -top-32 w-[520px] h-[520px] rounded-full bg-blue-500/30 blur-3xl animate-blob" />
      <div className="pointer-events-none absolute -left-32 -bottom-32 w-[460px] h-[460px] rounded-full bg-sky-400/25 blur-3xl animate-blob" style={{ animationDelay: "5s" }} />
      <div className="pointer-events-none absolute right-1/3 top-1/3 w-[300px] h-[300px] rounded-full bg-indigo-500/20 blur-3xl animate-blob" style={{ animationDelay: "8s" }} />
      {/* Subtle grid */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "48px 48px" }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">
              Limited spots this week
            </div>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light leading-tight">
              Get Your <span className="font-medium">Free Quote</span> Today
            </h2>
            <p className="mt-4 text-blue-100/90 max-w-xl leading-relaxed">
              Book your cleaning in minutes. Fast response. No obligation. Quotes
              tailored to your property and schedule.
            </p>
          </div>

          <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3">
            <Link
              to="/contact"
              data-testid="cta-book-btn"
              className="group inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md text-sm font-semibold text-blue-900 bg-white hover:bg-blue-50 transition-all active:scale-[0.98] shadow-glow-blue ring-1 ring-white/40"
            >
              Book Now
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            <a
              href={`tel:${COMPANY.phoneClean}`}
              data-testid="cta-call-btn"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md text-sm font-semibold text-white bg-blue-700 hover:bg-blue-600 border border-blue-600 transition-all"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md text-sm font-semibold text-white bg-[#25D366] hover:bg-[#1EBE5D] transition-all"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
